import React, { useEffect, useState } from "react";
import "./App.css";
import QRCode from "react-qr-code";

function App() {
  const [value, setValue] = useState(null);
  useEffect(() => {
    fetch("https://yun.bolink.club/wit/faceuserpermissiongrouptb/selectTkEr", {
      method: "POST",
      body: JSON.stringify({
        mobile: '13000000000',
        projectId: 3916,
        currentTime: Date.now() / 1000,
        userId: 2292772,
        expirationTime: 5,
        allList: 0,
        deviceId: 1630,
        floorId: 18556,
        deviceType: 1,
      }),
      headers: {
        "Content-Type": "application/json",
      }
    }).then(res => res.json()).then(res => {
      setValue(res.data)
    })
  }, []);
  return (
    <div className="App">
      <p>18楼</p>
      {value && <QRCode size={256} value={value} />}
    </div>
  );
}

export default App;
